module.exports = __webpack_public_path__ + "static/media/museum-back.6695f023.png";